import { render, staticRenderFns } from "./PrefectureSelect.vue?vue&type=template&id=a8e15732&"
import script from "./PrefectureSelect.vue?vue&type=script&lang=js&"
export * from "./PrefectureSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports